// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_o62kR","foot_link":"index_foot_link_Gbj7u","list":"index_list_mEu-4","link":"index_link_pYEmj","copyright":"index_copyright_4bew4"};